import { EN } from "./en";
import { RU } from "./ru";

export default { EN, RU };
